import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from '../supabase';
import AdminNav from '../components/AdminNav';

export default function SurveyList() {
    const navigate = useNavigate();
    const [surveys, setSurveys] = useState([]);
    const [loading, setLoading] = useState(true);
    const [username, setUsername] = useState('');
    const [role, setRole] = useState('');

    useEffect(() => {
        const checkUser = async () => {
            const { data } = await supabase.auth.getSession();
            if (!data.session) {
                navigate('/login');
            }
        };
        checkUser();
    }, [navigate]);

    useEffect(() => {
        const fetchUser = async () => {
            const { data } = await supabase.auth.getSession();
            if (!data.session) return;
            const { data: userData } = await supabase
                .from('users')
                .select('username, role')
                .eq('email', data.session.user.email)
                .single();
            if (userData) { setUsername(userData.username); setRole(userData.role); }
        };
        fetchUser();
    }, []);

    useEffect(() => {
        const fetchSurveys = async () => {
            const { data } = await supabase
                .from('surveys')
                .select('*, survey_answers(count)')
                .order('created_at', { ascending: false });
            if (data) setSurveys(data);
            setLoading(false);
        };
        fetchSurveys();
    }, []);

    const handleLogout = async () => {
        await supabase.auth.signOut();
        navigate('/login');
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif' }}>

            {/* Topbar */}
            <AdminNav
                username={username}
                role={role}
                onLogout={handleLogout}
                activePath="/admin/surveys"
            />

            {/* Main */}
            <div style={{ flex: 1, padding: '24px 28px', overflowY: 'auto', background: '#f7f7f7' }}>

                {/* Header */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <div>
                        <p style={{ fontSize: '10px', fontWeight: '500', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#aaa', margin: '0 0 4px' }}>Admin</p>
                        <h1 style={{ fontWeight: '400', fontSize: '20px', color: '#111', margin: 0 }}>Surveys</h1>
                    </div>
                    <button onClick={() => navigate('/admin/surveys/new')} style={{ padding: '8px 16px', background: 'black', color: 'white', border: 'none', borderRadius: '6px', fontSize: '12px', cursor: 'pointer' }}>+ New survey</button>
                </div>

                {loading && <div style={{ textAlign: 'center', padding: '60px', color: '#aaa', fontSize: '13px' }}>Chargement...</div>}

                {!loading && surveys.length === 0 && (
                    <div style={{ textAlign: 'center', padding: '60px', color: '#aaa', fontSize: '13px' }}>
                        Aucun survey pour l'instant. Crée ton premier !
                    </div>
                )}

                {/* Liste surveys */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {surveys.map((s) => (
                        <div key={s.id} style={{ background: 'white', border: '0.5px solid #e0e0e0', borderRadius: '10px', padding: '16px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                            onClick={() => navigate(`/admin/surveys/${s.id}`)}>
                            <div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                                    <span style={{ fontSize: '14px', fontWeight: '500', color: '#111' }}>{s.title}</span>
                                    <span style={{ fontSize: '10px', padding: '2px 8px', borderRadius: '10px', background: s.published ? '#f0fdf4' : '#f5f5f5', color: s.published ? '#22c55e' : '#aaa', border: `0.5px solid ${s.published ? '#22c55e' : '#e0e0e0'}` }}>
                                        {s.published ? 'Publié' : 'Brouillon'}
                                    </span>
                                </div>
                                <div style={{ fontSize: '11px', color: '#aaa' }}>
                                    {new Date(s.created_at).toLocaleDateString('fr-CA')} · /s/{s.slug} · {s.survey_answers[0].count} réponse{s.survey_answers[0].count !== 1 ? 's' : ''}
                                </div>
                            </div>
                            <span style={{ fontSize: '18px', color: '#ccc' }}>→</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}